import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ChartOfAccContainerModel} from '../../../../../models/aggregates/';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';


@Injectable({
  providedIn: 'root'
})
export class ChartOfAccService extends BaseApiTemplateService<ChartOfAccContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'chart-of-acc';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'chart-of-acc';
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'chart-of-acc';
    this.httpClient = http;
  }

}
